import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CreditStatus } from '@payments/constants/payment-dashboard';
import { CustomerSellerMetrics } from '@payments/models/payment-dashboard-page-view.model';
import { PaymentDashboardAnalyticsService } from '@payments/pages/payment-dashboard/tracking/analytics/payment-dashboard-analytics.service';
import { PaymentsModalService } from '@payments/services/payments-modal.service';
import { PATHS } from '@shared/constants/paths';
import { InvoiceFilterIds } from '@usf/ngrx-payment';

@Component({
  template: '',
})
export class PaymentDashboardRowsComponent {
  @Input() customerMetrics: CustomerSellerMetrics;

  readonly CreditStatus = CreditStatus;

  isPresentingSellers = false;

  constructor(
    readonly router: Router,
    protected paymentDashboardAnalytics: PaymentDashboardAnalyticsService,
    protected paymentsModalService: PaymentsModalService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {}

  goToAllInvoices() {
    const queryParams = {
      [InvoiceFilterIds.Customers]: `${this.customerMetrics.customerNumber},`,
    };
    this.paymentDashboardAnalytics.trackOutboundLink(
      `${PATHS.PAYMENTS_ALL_INVOICES}?${InvoiceFilterIds.Customers}=${this.customerMetrics.customerNumber}`,
    );
    this.router.navigate([PATHS.PAYMENTS_ALL_INVOICES], { queryParams });
  }

  showSellers(event) {
    if (
      !this.customerMetrics.allSellers ||
      this.customerMetrics.allSellers?.length < 2
    ) {
      return;
    }
    event.stopPropagation();
    this.isPresentingSellers = true;
    this.paymentsModalService.presentSellersForCustomer(
      event,
      this.customerMetrics.allSellers,
      () => {
        this.isPresentingSellers = false;
        this.changeDetectorRef.detectChanges();
      },
    );
  }
}
